angular.module('tasks')
    .component('rentalAgreementShow', {
        bindings: {
            item: '<'
        },
        templateUrl: 'app/rental/agreement/show.html',
        controller: function ($scope, $state, $window, RentalAgreementService, RentalResourceService, Principal) {
            this.RentalAgreementService = RentalAgreementService
            this.RentalResourceService = RentalResourceService
            this.$onInit = () => {
                this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])
            }

            this.cancel = () => {
                if ($window.history.length > 2)
                    $window.history.back();
                else {
                    $state.go('home');
                }
            }

            $scope.$on('task.updated', () => $state.reload());
            $scope.$on('task.deleted', () => this.cancel());
        }
    })
